// Generated types for PDMPart
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { PDMPortWriteAPI } from './pdmport';
import { PartDefinitionReadAPI, PartDefinitionWriteAPI } from '../../sysml/types/partdefinition';
import { PDMPortWriteAPISchema } from './pdmport';
import { PartDefinitionWriteAPISchema, PartDefinitionReadAPISchemaObject, PartDefinitionWriteAPISchemaObject } from '../../sysml/types/partdefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PDMPartReadAPI extends PartDefinitionReadAPI {
  /** Type of part: MECHANICAL, ELECTRICAL, SOFTWARE, ASSEMBLY */
  part_type?: string;
  /** Primary material */
  material?: string | null;
  /** Mass in kg */
  mass?: number | null;
  /** Target cost */
  cost_target?: number | null;
}

export interface PDMPartWriteAPI extends PartDefinitionWriteAPI {
  sub_parts?: (string | PartDefinitionWriteAPI)[];
  /** Type of part: MECHANICAL, ELECTRICAL, SOFTWARE, ASSEMBLY */
  part_type?: string;
  /** Primary material */
  material?: string | null;
  /** Mass in kg */
  mass?: number | null;
  /** Target cost */
  cost_target?: number | null;
  /** Ports of this part */
  ports?: (string | PDMPortWriteAPI)[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PDMPartReadAPISchema: z.ZodType<PDMPartReadAPI> = PartDefinitionReadAPISchemaObject.extend({
  part_type: z.string().optional(),
  material: z.string().nullable().optional(),
  mass: z.number().nullable().optional(),
  cost_target: z.number().nullable().optional(),
}).passthrough();

export const PDMPartWriteAPISchema: z.ZodType<PDMPartWriteAPI> = PartDefinitionWriteAPISchemaObject.extend({
  sub_parts: z.array(z.union([z.string(), z.lazy(() => PartDefinitionWriteAPISchema)])).optional(),
  part_type: z.string().optional(),
  material: z.string().nullable().optional(),
  mass: z.number().nullable().optional(),
  cost_target: z.number().nullable().optional(),
  ports: z.array(z.union([z.string(), z.lazy(() => PDMPortWriteAPISchema)])).optional(),
}).passthrough();
